import { useEffect, useCallback } from "react";

declare global {
  interface Window {
    Cal?: any;
  }
}

const CAL_LINK = "maxim-rousseau-6ciolz/premier-contact-accompagnement-strategique";
const CAL_NAMESPACE = "premier-contact-accompagnement-strategique";

export const initCalEmbed = () => {
  if (typeof window === 'undefined') return;
  
  if (!window.Cal) {
    (function (C: any, A: string, L: string) {
      let p = function (a: any, ar: any) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");
  }

  window.Cal("init", CAL_NAMESPACE, { origin: "https://app.cal.com" });
  window.Cal.ns?.[CAL_NAMESPACE]?.("ui", { 
    hideEventTypeDetails: false, 
    layout: "month_view" 
  });
};

export const openCalModal = () => {
  if (window.Cal?.ns?.[CAL_NAMESPACE]) {
    window.Cal.ns[CAL_NAMESPACE]("openModal", {
      calLink: CAL_LINK,
    });
  }
};

export const useCalEmbed = () => {
  useEffect(() => {
    initCalEmbed();
  }, []);

  const openModal = useCallback(() => {
    openCalModal();
  }, []);

  return { openModal };
};

// Lien de booking 15 minutes (GoHighLevel) — section calendrier /plan-de-match
export const BOOKING_15MIN_URL =
  "https://api.leadconnectorhq.com/widget/booking/kF5vOoLTg7gKw4lohxYJ";

// Lien de booking utilisé partout ailleurs (page principale + widget « Réserver un appel »)
export const BOOKING_MAIN_URL =
  "https://api.leadconnectorhq.com/widget/booking/vqjOpHbygZvBRmpByDVX";

export const OPEN_BOOKING_15MIN_EVENT = "open-booking-15min";

export const openBooking15Min = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(OPEN_BOOKING_15MIN_EVENT, {
      detail: { openedAt: Date.now() },
    }),
  );
};

// À spreader sur un Button pour ouvrir la modale de réservation (style Cal.com)
export const booking15MinProps = {
  onClick: openBooking15Min,
};

// Les CTA du site ouvrent la modale de réservation GHL
export const calButtonProps = {
  onClick: openBooking15Min,
};



export { CAL_LINK, CAL_NAMESPACE };
